<template>
  <sui-page>
    <sui-page-header title="상신 의견" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <h4>결재 정보</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TIT_TTL')" />
          </div>
          <div class="col-xs-11">
            {{ pageInitialData.approvalTitle }}
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TIT_OPN')" />
          </div>
          <div class="col-xs-11">
            <sui-textarea
              v-model="approvalOpinionContent"
              extensible
              :rows="5"
              :maxlength="1024"
            />
          </div>
        </div>
      </div>
    </sui-page-contents>
    <!-- Page Footer -->
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <!-- 취소 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t("MSG_BTN_CNCL") }}
        </sui-button>
        <!-- 상신 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickProposal"
        >
          {{ $t("MSG_TXT_SUBM") }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CML_00011', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: false,
      default() {
        return {
          approvalTitle: '',
        };
      },
    },
  },
  data() {
    return {
      approvalOpinionContent: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    if (utils.trim(this.pageInitialData.approvalTitle) === '') {
      // TODO:
      utils.messageBox('warning', '확인', '제목이 존재하지 않습니다.', () => {

      });
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * '취소' 버튼 click event handler
     */
    onClickCancel() {
      this.closePagePopup({
        goProposal: false,
      });
    },
    /**
     * '상신취소' 버튼 click event handler
     */
    onClickProposal() {
      this.closePagePopup({
        goProposal: true,
        approvalOpinionContent: this.approvalOpinionContent,
      });
    },
  },
};
</script>
<style scoped>
</style>
